import { CellAlign, EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { IProviderField, PROVIDER_DATA_TYPE_ENUM } from '../interfaces/IProviderField';
import { ProviderFieldRowActions } from '../components/ProviderFieldRowActions';
import { PROVIDER_FIELD_PERMISSIONS } from './provider-field.permissions';
import { BooleanCell } from 'modules/common/components/BooleanCell';
import { ProviderFieldFixedValuesCell } from '../components/ProviderFieldFixedValuesCell';
import { Chip } from '@mui/material';
import i18next from 'i18next';

const DATA_TYPE_COLOR: Record<PROVIDER_DATA_TYPE_ENUM, 'info' | 'warning' | 'success' | 'secondary'> = {
  [PROVIDER_DATA_TYPE_ENUM.STRING]: 'info',
  [PROVIDER_DATA_TYPE_ENUM.NUMBER]: 'warning',
  [PROVIDER_DATA_TYPE_ENUM.BOOLEAN]: 'success',
  [PROVIDER_DATA_TYPE_ENUM.ARRAY]: 'secondary',
};

export const providerFieldLabelColumn: HeadCell<IProviderField> = {
  field: 'label',
  headerName: 'providerField:fields.label',
  renderCell: (key: string, data?: IProviderField) => <EditLink entityId={data?._id as string}>{key}</EditLink>,
};

export const providerFieldProviderTypeColumn: HeadCell<IProviderField> = {
  field: 'providerType',
  headerName: 'providerField:fields.providerType',
  renderCell: (providerType: string) => (
    <span>{i18next.t(`providerField:PROVIDER_TYPE.${providerType}`)}</span>
  ),
};

export const providerFieldDataTypeColumn: HeadCell<IProviderField> = {
  field: 'dataType',
  headerName: 'providerField:fields.dataType',
  renderCell: (dataType: PROVIDER_DATA_TYPE_ENUM) => (
    <Chip
      size='small'
      label={i18next.t(`providerField:DATA_TYPE.${dataType}`)}
      color={DATA_TYPE_COLOR[dataType] ?? 'default'}
    />
  ),
};

export const providerFieldRequiredColumn: HeadCell<IProviderField> = {
  field: 'required',
  headerName: 'errors:required',
  component: BooleanCell,
  align: CellAlign.CENTER,
};

export const providerFieldDefaultValueColumn: HeadCell<IProviderField> = {
  field: 'defaultValue',
  headerName: 'providerField:fields.defaultValue',
  renderCell: (value: any) => (value != null && value !== '' ? <span>{String(value)}</span> : null),
};

export const providerFieldFixedValuesColumn: HeadCell<IProviderField> = {
  field: 'fixedValues',
  headerName: 'providerField:fields.fixedValues',
  component: ProviderFieldFixedValuesCell,
};

export const providerFieldActionsColumn: HeadCell<IProviderField> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: PROVIDER_FIELD_PERMISSIONS.PROVIDER_FIELD_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: ProviderFieldRowActions,
};

export const providerFieldColumns: Array<HeadCell<any>> = [
  providerFieldLabelColumn,
  providerFieldProviderTypeColumn,
  providerFieldDataTypeColumn,
  providerFieldRequiredColumn,
  providerFieldDefaultValueColumn,
  providerFieldFixedValuesColumn,
  createdATColumn,
  providerFieldActionsColumn,
];
